import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
function compileTpl(tpl) {
  var re = /\$\{([^}]+)?\}/g;
  var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
  var code = 'with(data){ var r=[];\n';
  var cursor = 0;
  var match;
  var add = function add(line, js) {
    js ? code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n' : code += line !== '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '';
    return add;
  };
  while (match = re.exec(tpl)) {
    add(tpl.slice(cursor, match.index))(match[1], true);
    cursor = match.index + match[0].length;
  }
  add(tpl.substr(cursor, tpl.length - cursor));
  code += 'return r.join("");};';
  // eslint-disable-next-line
  return new Function('data', code.replace(/[\r\t\n]/g, ''));
}
function expression(expression) {
  var compiled = null;
  return function (data) {
    if (!compiled) {
      compiled = compileTpl(expression);
    }
    return compiled(data);
  };
}
function _default(val) {
  return val;
}
function object(val, config, instance) {
  return processor(val, config.properties, instance);
}
var processors = {
  expression: expression,
  object: object,
  _default: _default
};
export default function processor(settingValue, settingConfig) {
  var instance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  for (var key in settingConfig) {
    var config = settingConfig[key];
    var value = settingValue[key];
    var _processor = processors[config.type] || processors._default;
    settingValue[key] = _processor(value, config, instance);
  }
  return settingValue;
}